<header class="quality-header">
  <h2>کیفیت اثر انگشت</h2>
  <span lang="en">DATA QUALITY</span>
</header>

<div class="gauge" tabindex="0" role="img" [attr.aria-label]="confidence === null ? 'امتیاز کیفیت داده موجود نیست' : 'امتیاز کیفیت داده: ' + confidence + ' درصد'">
  <app-chart [context]="chartContext" aria-hidden="true"></app-chart>
  <div class="gauge-label">
    <span *ngIf="confidence === null" class="no-confidence">—</span>
    <small>امتیاز کیفیت داده</small>
  </div>
  <div *ngIf="confidence !== null" class="gauge-details">
    <span>{{ confidence | number:'1.1-1':'en-US' }} از 100</span>
    <small>{{ context.summary?.iRecordCount ?? '—' }} رکورد بررسی‌شده</small>
  </div>
</div>

<div class="quality-footer">
  <span>روزهای ثبت‌شده: <b>{{ dayCounts.totalDays ?? '—' }}</b></span>
  <span>واجد شرایط تحلیل: <b>{{ dayCounts.eligibleDays ?? '—' }}</b></span>
  <span>واجد شرایط الکتریکی: <b>{{ dayCounts.electricalDays ?? '—' }}</b></span>
  <span>روزهای معتبر مرجع الکتریکی: <b>{{ baselineElectricalDays ?? '—' }}</b></span>
</div>
